import { useCallbackRef as e } from "@radix-ui/react-use-callback-ref";
import * as t from "react";
export function useEscapeKeydown(n) {
  var o = e(n);
  t.useEffect(function () {
    var e = function e(_e) {
      "Escape" === _e.key && o(_e);
    };

    return document.addEventListener("keydown", e), function () {
      return document.removeEventListener("keydown", e);
    };
  }, [o]);
}